module.exports = __webpack_public_path__ + "static/media/icon-score-scale-gray.98ff0396.svg";